'use strict';

/*global __webpack_modules__ __webpack_require__*/
/**
 * Perform initialization.
 *
 * This module aims to do complete everything synchronously, before
 * the experiment developer's code begins.
 *
 * Note: This module is designed to be run as the first thing in a chunk.
 */

var WithdrawExperimentException = require('./withdraw-experiment-exception');
var assign = require('object-assign');
var manifest = assign(require('./manifest'), {"cohortId":"28329143","experimentId":"EXPERIMENT-2176","cohortName":"control","product":"JIRA","browsers":{"chrome":"55","firefox":"50"},"eventPrefix":"grow0.experiment2176"});
var bowser = require('bowser');
if (!bowser.check(manifest.browsers || {}, true)) {
  throw new WithdrawExperimentException();
}

var analytics = require('analytics');
try {
  /**
   * Setup error reporting for unhandled rejections.
   */
  Promise.unhandledRejection = function (reason) {
    var bubbleUpError = require('./bubble-up-error');
    bubbleUpError(reason);
    analytics.error(reason);
  };

  var context = require('context');
  analytics.setContext(context);

  require("/opt/bamboo-agent/bamboo-agent-home/xml-data/build-dir/PGT-EXP2-BUILD/src/GROW-4967-EXPERIMENT-2176/src/control/jira");
} catch (e) {
  if (!(e instanceof WithdrawExperimentException)) {
    analytics.error(e);
    throw e;
  }
}
/**
 * Dedicated to Austin! <3
 */


//////////////////
// WEBPACK FOOTER
// ./~/callback-loader/callback-loader.js?getManifest&getExperimentModule&config=callback-control-jira!./~/@atlassiansox/experiment-common-core/lib/initializer.js
// module id = 0
// module chunks = 0